import { createElement } from 'react';

import { cn } from '@/lib/utils';

import type { Sugerencia } from '../asistente.types';
import { resolveSuggestionIcon } from '../lib/suggestion-icons';

interface SuggestionListProps {
  sugerencias: Sugerencia[];
  onSelect: (texto: string) => void;
  disabled?: boolean;
  className?: string;
}

/** Consultas sugeridas que el usuario puede lanzar con un clic. */
export function SuggestionList({ sugerencias, onSelect, disabled = false, className }: SuggestionListProps) {
  if (sugerencias.length === 0) return null;

  return (
    <ul className={cn('grid w-full grid-cols-1 gap-2 sm:grid-cols-2', className)}>
      {sugerencias.map((sugerencia) => (
        <li key={sugerencia.texto} className="min-w-0">
          <button
            type="button"
            disabled={disabled}
            onClick={() => onSelect(sugerencia.texto)}
            className={cn(
              'group flex h-full w-full cursor-pointer items-center gap-2 rounded-xl border border-ink-100 bg-white px-3 py-2',
              'text-left text-xs text-ink-700 transition-all',
              'hover:border-brand-200 hover:bg-brand-50/50 disabled:cursor-not-allowed disabled:opacity-60',
            )}
          >
            <span
              aria-hidden="true"
              className="shrink-0 text-brand-500 transition-colors group-hover:text-brand-600"
            >
              {createElement(resolveSuggestionIcon(sugerencia.icono), { className: 'size-4' })}
            </span>
            <span className="leading-snug">{sugerencia.texto}</span>
          </button>
        </li>
      ))}
    </ul>
  );
}
